export default [
    {
        path: '/changeentry', // 无订单非自愿改期
        component: resolve => require(['@/pages/reform/changeentry'], resolve),
        meta: { title: "长龙航空" }
    },
    {
        path: '/entrance', // 入口
        component: resolve => require(['@/pages/entrance'], resolve),
        meta: { title: "长龙航空" }
    }
   
]



// WEBPACK FOOTER //
// ./src/router/modules/changedate.js